import React from "react";

export const money = (n) => n == null ? "—" : `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const num = (n) => Number(n || 0).toLocaleString();

const BADGE = {
  draft: "bg-race-line/40 text-race-sub",
  pending_review: "bg-amber-400/15 text-amber-300 border border-amber-400/30",
  changes_requested: "bg-orange-500/15 text-orange-300 border border-orange-500/30",
  scheduled: "bg-sky-500/15 text-sky-300 border border-sky-500/30",
  active: "bg-race-volt/15 text-race-volt border border-race-volt/30",
  paused: "bg-race-line/40 text-race-sub border border-race-line",
  rejected: "bg-race-red/15 text-race-red border border-race-red/30",
  completed: "bg-emerald-500/15 text-emerald-300 border border-emerald-500/30",
};

export const StatusBadge = ({ status, label }) => (
  <span data-testid={`adv-status-${status}`} className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wide ${BADGE[status] || BADGE.draft}`}>
    {label || status}
  </span>
);

export const Metric = ({ label, value, sub, testid }) => (
  <div className="bg-race-surface border border-race-line rounded-lg p-5" data-testid={testid}>
    <div className="text-[11px] uppercase tracking-wide text-race-muted">{label}</div>
    <div className="font-heading text-3xl mt-1.5 tracking-tight">{value}</div>
    {sub && <div className="text-xs text-race-sub mt-1">{sub}</div>}
  </div>
);

export const STATUS_HELP = {
  draft: "Not submitted yet. Finish and submit for review.",
  pending_review: "Submitted and awaiting approval from the Text Racing team.",
  changes_requested: "The team asked for changes. Update and resubmit.",
  scheduled: "Approved and scheduled to begin on its start date.",
  active: "Currently serving to your audience.",
  paused: "Not serving right now.",
  rejected: "This campaign was not approved.",
  completed: "Reached its end date or delivery limit.",
};
